import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutChristelConstruction from './routes/about-christel-construction'
import services from './routes/services'
import employeePortal from './routes/employee-portal'
import preQualification from './routes/pre-qualification'
import portfolio from './routes/projects'
import singleBrochures from './routes/single-brochures'

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
	/** About Us page, note the change from about-us to aboutUs. */
	aboutChristelConstruction,
	services,
	employeePortal,
	preQualification,
	portfolio,
	singleBrochures
})

/** Load Events */
routes.loadEvents()
